import { useQuery } from '@tanstack/react-query';
import { fetchMe } from '../lib/adminApi';
import { ApiError } from '../lib/staffAuth';
import { emptyPermissions, type StaffMe, type StaffPermissions } from '../types/auth';

export function useStaffMe() {
  return useQuery({
    queryKey: ['me'],
    queryFn: fetchMe,
    retry: (failureCount, error) => {
      if (error instanceof ApiError && error.status === 401) {
        return false;
      }
      return failureCount < 3;
    },
  });
}

export function isAdmin(me?: StaffMe | null): boolean {
  return me?.role === 'admin';
}

export function can(
  me: StaffMe | null | undefined,
  area: keyof StaffPermissions,
  action: string,
): boolean {
  if (!me) return false;
  if (me.role === 'admin') return true;
  const block = me.permissions?.[area] as Record<string, boolean> | undefined;
  return Boolean(block?.[action]);
}

export function permissionsOf(me?: StaffMe | null): StaffPermissions {
  return me?.permissions ?? emptyPermissions();
}
